/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Slider from '@dtvgo/slider';

function Progress({ progress, duration }) {
  return (
    <div className="dtv-html5-c-card-episode__progress">
      <Slider
        value={progress}
        minValue={0}
        maxValue={duration}
      >
        <Slider.Fill />
      </Slider>
    </div>
  );
}

Progress.propTypes = {
  progress: PropTypes.number,
  duration: PropTypes.number,
};

Progress.defaultProps = {
  progress: 0,
  duration: 100,
};

export default memo(Progress);
